import React from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';

import styled from 'styled-components';

import { Icon, IconsNames } from 'atoms';
import { getFontFamily } from 'services/FontService';

export interface IDateSelect extends IDateStyle {
  name?: string;
  value: Date | null;
  placeholder?: string;
  className?: string;
  defaultValue?: Date;
  disabled?: boolean;
  onChange: (value: Date | null) => void;
  disabledDate?: (date: Date) => boolean;
}

export interface IDateStyle {
  hasError?: boolean;
  disabled?: boolean;
}

export const DateSelect = ({
  name,
  value,
  placeholder,
  hasError = false,
  className,
  disabled,
  defaultValue,
  onChange,
  disabledDate,
}: IDateSelect) => (
  <StyledDatePicker
    className={className}
    name={name}
    defaultValue={moment(defaultValue)}
    value={value ? moment(value) : null}
    placeholder={placeholder}
    style={{ height: '48px', width: '100%' }}
    onChange={(changedValue) =>
      changedValue ? onChange(changedValue.toDate()) : undefined
    }
    format="DD.MM.YYYY"
    hasError={hasError}
    disabled={disabled}
    suffixIcon={
      <Icon
        name={IconsNames.CalendarIcon2}
        height="16"
        width="16"
        color={disabled ? 'var(--k-fg-c6ccd0)' : 'var(--k-fg-0d53fc)'}
      />
    }
    disabledDate={
      disabledDate ? (date) => disabledDate(date.toDate()) : undefined
    }
  />
);

const StyledDatePicker = styled(DatePicker)<IDateStyle>`
  font-family: ${getFontFamily('regular')};
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--k-border-f44336)'
        : 'var(--k-border-ebeff2)'} !important;
  box-shadow: none;
  cursor: pointer;
  background-color: ${({ disabled }) =>
    disabled ? 'var(--k-bg-fafbfd)' : 'var(--k-bg-ffffff)'} !important;

  & input {
    &::placeholder {
      color: var(--k-fg-616e78);
    }
  }

  & input[disabled] {
    color: var(--k-fg-263446);
  }
  .ant-picker-clear {
    display: none;
  }

  &:hover {
    border-color: var(--k-border-ebeff2);
  }

  &.ant-picker-focused {
    border-color: var(--k-border-0d53fc);
  }
`;
